import {Injectable} from '@angular/core';
import {HttpClient,} from '@angular/common/http';
import {select, Store} from '@ngrx/store';

import * as fromRoot from '../../../../reducers';
import * as fromAfbApi from '../../../../afb-api/reducers';

import {ITriggerStore} from '../../../shared';

import {combineLatest, Observable} from 'rxjs';

import {Device} from '../../../../afb-api/models/device';

@Injectable()
export class TriggerService {

  constructor(private httpClient: HttpClient,
              private afbApiStore: Store<fromAfbApi.State>,
              private store: Store<fromRoot.State>) {
  }

  getDeviceXTrigger() {
    const deviceEntities$: Observable<{ [deviceUuid: string]: Device }> = this.afbApiStore.pipe(
      select(fromAfbApi.deviceEntities)
    );
    const triggerEntities$: Observable<{ [deviceUuid: string]: ITriggerStore }> = this.store.pipe(
      select(fromRoot.getTriggerEntities)
    );

    return combineLatest(deviceEntities$, triggerEntities$,
      (deviceEntities: { [deviceUuid: string]: Device }, triggerEntities: { [deviceUuid: string]: ITriggerStore }) => {
        return Object.keys(deviceEntities).reduce(
          (accumulator: { [deviceUuid: string]: { device: Device, trigger: ITriggerStore } }, key: string) => {
            return {
              ...accumulator, [key]: {
                device: deviceEntities[key],
                trigger: triggerEntities[key]
              }
            };
          }, {});
      });
  }
}
